type NodeEnvString = 'production' | 'homolog' | 'development' | undefined;
export const NODE_ENV = process.env.REACT_APP_NODE_ENV as NodeEnvString;

export const PUBLIC_ENV = {
  APP_URL: process.env.REACT_APP_URL,
  API_URL: process.env.REACT_APP_API_URL,
};

export const ROUTES = {
  home: '/',
  auth: {
    login: '/login',
    newPass: '/login/new-password',
    resetPass: '/login/reset-password',
  },
  users: {
    create: '/users/create',
    index: '/users',
    me: '/users/me',
    edit: (id: number | string) => `/users/${id}/edit`,
    disable: (id: number | string) => `/users/disable/${id}`,
  },
  calendars: {
    index: '/calendars',
  },
  classes: {
    given: '/classes/given',
  },
  reports: {
    index: '/reports',
  },
  subjects: {
    index: '/subjects',
  },
  payments: {
    index: '/payments',
    send: '/payments/send',
  },
} as const;
